import { useState } from 'react'
import { useSsoToken } from './useSsoToken'
import { createFileNoteCaseNote } from '../services/claimsApi'
import { getApiErrorMessage } from '../utils/errorMessages'

// Saves a File Note case note against the connected claim (MSD-236/237).
// `save` resolves to true on success so the caller can close the form.
export function useAddFileNote(claimNumber: string) {
  const { getToken } = useSsoToken()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const save = async (description: string, detail: string): Promise<boolean> => {
    setSaving(true)
    setError(null)
    try {
      const token = await getToken()
      // Description is required by the form; an empty Details field is sent as
      // null (the backend accepts either field being absent, not both).
      await createFileNoteCaseNote(
        claimNumber,
        { fileNoteDescription: description, fileNoteDetail: detail.trim() ? detail : null },
        token
      )
      return true
    } catch (err: unknown) {
      console.error('[AddFileNote] Failed to save file note:', err)
      setError(getApiErrorMessage(err, 'Failed to save the file note. Please try again.'))
      return false
    } finally {
      setSaving(false)
    }
  }

  return { saving, error, save }
}
